<div class="tco-header-shell">
  <div class="tco-heading">{{ title }}</div>
  <div class="tco-subheading" *ngIf="subtitle">{{ subtitle }}</div>

  <div class="tco-legend-row">
    <ng-container *ngIf="shouldShowMarkerLegends">
      <div class="marker-legend-item" *ngFor="let item of markerLegends">
        <span class="marker-badge">{{ item.shortLabel }}</span>
        <span class="marker-legend-label">{{ item.label }}</span>
      </div>
    </ng-container>

    <div class="legend-item" *ngFor="let item of legends">
      <span class="legend-swatch" [style.background]="item.color"></span>
      <span class="legend-label">{{ item.label }}</span>
    </div>
  </div>
</div>
